import { oktaAuth } from '../components/login/config';

export const getHTTPHeaders = () => {
  const tokens = oktaAuth?.tokenManager.getTokensSync();
  if (
    !tokens?.accessToken ||
    oktaAuth.tokenManager.hasExpired(tokens.accessToken)
  ) {
    if (oktaAuth?.isAuthenticated()) {
      oktaAuth.signOut();
      window.onbeforeunload = undefined;
    }
    throw new Error('Missing or expired token');
  }
  return {
    headers: {
      Authorization: `${tokens.accessToken.tokenType} ${tokens.accessToken.accessToken}`,
    },
  };
};
